import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-help-logbook',
    templateUrl: './help-logbook.component.html',
    styleUrls: ['./help-logbook.component.css'],
    standalone: false
})
export class HelpLogbookComponent implements OnInit {

  // images
  @Input() getImgs: string[] = [];
  @Output() showImg: EventEmitter<string> = new EventEmitter<string>();

  constructor() {

  }

  ngOnInit(): void {

  }

  // show selected image on screen
  showImage(url: string): void {
    this.showImg.emit(url);
  }

}
